import TeamIcon from './TeamIcon';

export default TeamIcon;
